import React from 'react';
import { RocketIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://industrial-instrumentation-instructor-system-2026.impultienda.ar/checkout';
interface CtaButtonProps {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
  /** 'solid' is the primary orange button; 'outline' sits on top of the dark panels. */
  variant?: 'solid' | 'outline';
  fullWidth?: boolean;
  /** Hidden for compact bars where the icon would crowd the label. */
  showIcon?: boolean;
}
export function CtaButton({
  label = 'Get The Full System Now',
  size = 'lg',
  className = '',
  href = '#offer',
  variant = 'solid',
  fullWidth = false,
  showIcon = true
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizing = size === 'lg' ? 'px-9 py-4 text-lg sm:text-xl' : 'px-6 py-3 text-base';
  const tone = variant === 'outline' ? 'border border-ink-400/40 text-ink-50 hover:border-ember-400 hover:text-ember-300 focus-visible:outline-ember-400' : 'bg-ember-500 text-steel-950 shadow-lift hover:bg-ember-400 focus-visible:outline-ember-400';
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`group inline-flex items-center justify-center gap-3 rounded-full font-display font-semibold uppercase tracking-wide transition-[transform,background-color,border-color,color] duration-150 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-0 ${sizing} ${tone} ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-52" data-mp="39y7vvvpkf24g">
      {showIcon ? <RocketIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-53" data-mp="1io7b9zua7vq" /> : null}
      {label}
    </a>;
}